import axios from 'axios';
import {fullURL} from '../utils';

export const CUSTOM_REPORTS_SAVE = 'CUSTOM_REPORTS_SAVE';
export const CUSTOM_REPORTS_DELETE = 'CUSTOM_REPORTS_DELETE';
export const CUSTOM_REPORTS_RECEIVE = 'CUSTOM_REPORTS_RECEIVE';
export const CUSTOM_REPORTS_FETCH = 'CUSTOM_REPORTS_FETCH';

export default {
  state: {
    items: {}
  },

  mutations: {
    [CUSTOM_REPORTS_RECEIVE](state, {reports}) {
      state.items = reports.reduce((db, report) => ({
        ...db,
        [report.id]: report
      }), {});
    },

    [CUSTOM_REPORTS_SAVE](state, {report}) {
      state.items = {
        ...state.items,
        [report.id]: report
      };
    },

    [CUSTOM_REPORTS_DELETE](state, {id}) {
      delete state.items[id];
      state.items = {...state.items};
    }
  },

  actions: {
    async [CUSTOM_REPORTS_FETCH]({commit}) {
      const {data} = await axios.get(fullURL('/custom-reports'));
      commit({type: CUSTOM_REPORTS_RECEIVE, reports: data});
    },
  }
};
